import { useCurrentDatabaseManager } from "./useDatabases";
import { useNetworkState } from "../useNetworkState";
import { useCallback } from "react";
import { DatabaseIdentifier } from "./manager";

/**
 * Returns a function that should be called after every change to a Pouch database.
 *
 * If online, will try to sync the changes upstream (to the server), otherwise (or if unsuccessful) the database
 * will be marked as dirty so that the user knows that it needs syncing in the future.
 */
export function useHandlePouchChanges() {
  const mngr = useCurrentDatabaseManager();
  const { state } = useNetworkState();

  return useCallback(
    async (dependencies: DatabaseIdentifier[]) => {
      if (state === "online" || state === "online-slow") {
        // don't mark dirty yet since we're about to sync anyway
        mngr?.notifyNeedReload(dependencies, false);
        const successful = await mngr?.syncUp(dependencies);
        // only mark dirty if sync did not succeed
        mngr?.notifyNeedReload(dependencies, !successful);
      } else {
        // didn't sync yet; dirty, should sync later
        mngr?.notifyNeedReload(dependencies, true);
      }
    },
    [mngr, state]
  );
}
